import React, {useState} from 'react'
import {makeStyles} from '@material-ui/styles'
import {converge, ifElse, join, nthArg, prop, unapply} from 'ramda'

const TRANSITION_DURATION = '150ms'
const MAIN_OPACITY = 0.25
const PRESSED_OPACITY = 0.35
const BLUR_RADIUS = 18
const GLOW_OPACITY = 0.35

const transition = [
  `box-shadow ${TRANSITION_DURATION} ease-in`,
  `background ${TRANSITION_DURATION} ease-in`,
].join(', ')

function formatBoxShadow(blurRadius) {
  return `inset 0px 0px ${blurRadius}px rgba(255,255,255, ${GLOW_OPACITY})`
}

const useStyles = makeStyles({
  root: {
    padding: '8px 4px',
    font: 'inherit',
    display: 'block',
    margin: 'auto',
    width: 'calc(100% - 8px)',
    borderRadius: '4px',
    border: 'none',
    backgroundColor: `rgba(0,0,0, ${MAIN_OPACITY})`,
    color: 'white',
    '&:focus': {
      outline: 'none',
    },
    '&:disabled': {
      backgroundColor: `rgba(0,0,0, ${MAIN_OPACITY * 0.38})`,
    },
    boxShadow: formatBoxShadow(0),
    transition,
  },
  pressed: {
    backgroundColor: `rgba(0,0,0, ${PRESSED_OPACITY})`,
    boxShadow: formatBoxShadow(BLUR_RADIUS),
    '&:disabled': {
      backgroundColor: `rgba(0,0,0, ${MAIN_OPACITY * 0.38})`,
      boxShadow: formatBoxShadow(0),
    },
  },
})


export default function Button({className, ...props}) {
  const classes = useStyles()
  const [isPressed, setIsPressed] = useState(false)

  return <button
    className={joinArgsWithSpace(getClassName(classes, isPressed), className)}
    onTouchStart={() => setIsPressed(true)}
    onTouchEnd={() => setIsPressed(false)}
    onMouseDown={() => setIsPressed(true)}
    onMouseUp={() => setIsPressed(false)}
    {...props}
  />
}

const joinArgsWithSpace = unapply(join(' '))

const getClassName = ifElse(
  nthArg(1),
  converge(joinArgsWithSpace, [prop('root'), prop('pressed')]),
  prop('root'),
)